import { render, staticRenderFns } from "./park-temp-car-fee-holiday-rule.vue?vue&type=template&id=4504320a&"
import script from "./park-temp-car-fee-holiday-rule.vue?vue&type=script&lang=js&"
export * from "./park-temp-car-fee-holiday-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports